import { Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Preact from 'preact';
import { useTheme } from '@mui/material/styles';

export type Props = {
    show: boolean;
    message: string;
    close: () => void;
    width: string;
    paddingTop?: number;
    /**
     * The amount of time in miliseconds to wait before hiding the Alert. Undefined sets it to a 3000ms default
     */
    autoHideDuration?: number | undefined | 'disable';
};

export function Component(props: Props) {
    const theme = useTheme();
    return (
        <Snackbar
            key={props.message}
            open={props.show}
            onClose={props.close}
            autoHideDuration={
                props.autoHideDuration === undefined
                    ? 3000
                    : props.autoHideDuration === 'disable'
                    ? undefined
                    : props.autoHideDuration
            }
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            sx={{
                zIndex: theme.zIndex.appBar,
                // The translateY allows the parent to set padding at the top.
                // Practically, this is used to avoid being hidden by the appBar.
                // The translateX is taken from the MUI snackbar css. It positions the
                // snackbar correctly horizontally. Because there can only be one transform
                // property this needed repeating here to ensure the snackbar's correct position.
                transform: {
                    xs: `translateY(${props.paddingTop ?? 0}px) !important`,
                    sm: `translateY(${props.paddingTop ?? 0}px) translateX(-50%) !important`,
                },
            }}
        >
            <Alert
                onClose={props.close}
                sx={{
                    /* For some reason the standard Alert doesn't vertically center the message text. This makes it behave */
                    '.MuiAlert-message': { display: 'flex', alignItems: 'center' },
                }}
            >
                <Typography variant="body2">{props.message}</Typography>
            </Alert>
        </Snackbar>
    );
}
Component.displayName = 'Alert';
